module Tapas.Bindings {
    export interface IClassActiveArgs {
        elementClass: string;
        activeClass: string;
    }
    export class ClickToggleClassActive {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var params = valueAccessor();
            var value = ko.unwrap(params.observable);

            var elementClass = params.elementclass;
            var activeClass = params.activeclass;

            ko.utils.registerEventHandler(element, "click", function () {

                if ($(element).hasClass(activeClass)) {
                    $(element).removeClass(activeClass);
                } else {
                    $(elementClass).removeClass(activeClass);
                    $(element).addClass(activeClass);
                }
            });
        }
    }
    ko.bindingHandlers['clickToggleClassActive'] = new ClickToggleClassActive();
} 
